import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import pc_idea from '../views/pc/ideapage.vue'
import content from '../views/pc/content.vue'
import pc_project from '../views/pc/project.vue'
import signup from '../views/signup.vue'
import lineauthhandle from '../views/lineauthhandle.vue'
import slpauthhandle from '../views/slpauthhandle.vue'
import welcome from '../views/welcome.vue'
import dashboard from '../views/dashboard.vue'
import sms from '../views/sms.vue'
import smsok from '../views/smsok.vue'
import certification from '../views/certification.vue'
import lid from '../views/pc/lid.vue'
import sp from '../views/sp/sp_lid.vue'
import setname from '../views/setname.vue'
import sp_idea from '../views/sp/sp_idea.vue'
import sp_content from '../views/sp/sp_content.vue'
import sp_project from '../views/sp/sp_project.vue'
import sp_home from '../views/sp/sp_home.vue'
import slpLogintest from '../views/slpLogintest.vue'

import officerslogin from '../views/officerslogin.vue'

//Develop
import profiletest from '../views/profiletest.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: { title: 'Liqlid', desc: 'Liqlidのページ' }
  },
  {
    path: '/',
    name: 'welcome',
    component: welcome
  },  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
  },
  {
    path: '/sms',
    name: 'sms',
    component: sms
  },
  {
    path: '/smsfinish',
    name: 'smsfinish',
    component: smsok
  },
  {
    path: '/certification',
    name: 'certification',
    component: certification
  },
  {
    path: '/signup',
    name: 'signup',
    component: signup
  },
  {
    path: '/adminliq',
    name: 'adminliq',
    // route level code-splitting
    // this generates a separate chunk (kuri.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/kuri.vue'),
    meta: {
      requireAuth: true
    },

  },
  {
    path: '/setname',
    name: 'setname',
    component: setname,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/lid/:id',
    name: 'lid',
    component: lid,
    meta: {
      requireAuth: true
    },
    children:[
      {
        path: 'idea',
        name: 'idea',
        component: pc_idea,
      },
      {
        path: 'project',
        name: 'project',
        component: pc_project,
      },
      {
        path: 'content',
        name: 'content',
        component: content,
      },
    ]
  },
  {
    path: '/sp/:id',
    name: 'sp',
    component: sp,
    children:[
      {
        path: 'idea',
        name: 'sp_idea',
        component: sp_idea,
      },
      {
        path: 'project',
        name: 'sp_project',
        component: sp_project,
      },
      {
        path: 'content',
        name: 'sp_content',
        component: sp_content,
      }
    ]
  },
  {
    path: '/sp_home',
    name: 'sp_home',
    component: sp_home,
  },
  {
    path: '/profiletest',
    name: 'profiletest',
    component: profiletest,
    meta: {
      requireAuth: true
    }
  },
  // if no matches redirect to home
  { path: '*', redirect: '/home' }
]
const authConfig = JSON.parse(process.env.VUE_APP_AUTH || '{}')  // 例→ {"line":1,"slp":0,"officer":1}
if (authConfig.line == 1) {
  routes.push({
    path: '/lineauthhandle',
    name: 'lineauthhandle',
    component: lineauthhandle
  })
}

if (authConfig.slp == 1) {
  routes.push({
    path: '/slp_callback',
    name: 'slpauthhandle',
    component: slpauthhandle
  })
}

if (authConfig.officer == 1) {
  routes.push({
    path: '/officers-login',
    name: 'officerslogin',
    component: officerslogin
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.path == '/signup') {
    // /signupに遷移する直前に、localStorageに直前のpathを保存する
    localStorage.setItem('pathBeforeSignup', from.path)
  }
  next()
})

export default router
